import { dsa } from './catalogs/dsa';
import { systemDesign } from './catalogs/systemDesign';
import { react } from './catalogs/react';
import { javascript } from './catalogs/javascript';
import { interviewPrep } from './catalogs/interviewPrep';
import { aiFundamentals } from './catalogs/aiFundamentals';
import { aiEngineering } from './catalogs/aiEngineering';
import { aiInterviewPrep } from './catalogs/aiInterviewPrep';
import { mentorship } from './catalogs/mentorship';
import { frontendSystemDesign } from './catalogs/frontendSystemDesign';
import { angular } from './catalogs/angular';
import { foundation } from './catalogs/foundation';
import { completeInterviewKit } from './catalogs/completeInterviewKit';

// Export TRACKS from its own file
export { TRACKS } from './tracks';

export const CATALOG = {
  dsa,
  systemDesign,
  react,
  javascript,
  interviewPrep,
  aiFundamentals,
  aiEngineering,
  aiInterviewPrep,
  mentorship,
  frontendSystemDesign,
  angular,
  foundation,
  completeInterviewKit: completeInterviewKit(react, javascript, angular, frontendSystemDesign, interviewPrep)
};